import { serviceRequest } from 'utils/http';
import { ExternalReferralService, ExternalReferralCreateDto } from 'common/api';

export function createExternalReferralAPI(
  externalReferralCreateDto: ExternalReferralCreateDto
) {
  return serviceRequest(() =>
    ExternalReferralService.externalReferralControllerCreate(
      externalReferralCreateDto
    )
  );
}
